import React from "react";
import { I2cButton, I2cIcon } from "@webcomponents/i2cwebcomponents/dist/react";
import { useMutation } from "react-query";
import ReviewAttribute from "../../../Components/SharedComponent/ReviewAttribute/ReviewAttribute";
import { DataNotFound } from "../../../Components/SharedComponent/ReviewSummarySectionNotFound/DataNotFound";
import FilesUploadService from "../../../Services/FilesUploadService";
import { createFileDownloadMutation } from "./reviewSummaryUtils";

const UseCaseDocumentOverView = ({ data }) => {
  const fileDownload = useMutation(
    createFileDownloadMutation(FilesUploadService)
  );

  const downloadFile = (fileName) => {
    fileDownload.mutate(fileName);
  };

  if (!data) return <DataNotFound />;
  const { useCaseDocumentTemplateID, useCaseDocumentTemplateFiles } =
    data["10_0"];

  return (
    <React.Fragment>
      <>
        <div className="forms-instance" style={{ color: "#111" }}>
          <div i2c-grid="grid grid" className="review-summary-gap">
            <ReviewAttribute
              label="Templet ID"
              value={useCaseDocumentTemplateID || "-"}
            />
            <div i2c-grid="12@md">
              <ReviewAttribute
                label="Template Files"
                value={
                  useCaseDocumentTemplateFiles.length > 0 ? (
                    <div
                      className="file-listing-wrapper"
                    >
                      {useCaseDocumentTemplateFiles.map((file, index) => (
                        <div
                          key={index}
                         className="file-listing"
                        >
                          <span>{file}</span>
                          <I2cButton
                            size="small"
                            variant="link color"
                            onClick={() => {
                              downloadFile(file);
                            }}
                          >
                            <I2cIcon
                              slot="prefix"
                              name="linear-document-download"
                              label="download"
                            />
                          </I2cButton>
                        </div>
                      ))}
                    </div>
                  ) : (
                    "-"
                  )
                }
              />
            </div>
          </div>
        </div>
      </>
    </React.Fragment>
  );
};

export default UseCaseDocumentOverView;
